<template>
  <div class="tester_container">
    <div class="mgx_top_right_fixed">
      <div class="top_right_btn mgx_action_btn" @click="back">
        <span class="btn_text">{{ $t('end_tester') }}</span>
      </div>
    </div>

    <div class="tester_device_container">
      <!-- <div class="tester_travel">
                <mgx_travel :travel="travel" :monitorJourney="true" />
            </div> -->
      <div class="tester_device">
        <Virtual_devices v-slot="{ vk }" :is-disabled="true" :key-class-resolver="resolveTesterKeyClass">
          <div class="disabled" v-if="disabledKeys.includes(vk)"></div>
          <div class="highlighted selected" v-if="highlightedKeys.includes(vk)"></div>
          <div class="pressed clear_bg_color" v-else-if="selectedKeys.includes(vk)"></div>
        </Virtual_devices>
        <!-- {{ selectedKeys }}
        <template v-for="(item, index) in [0x41, 0x51, 0x57, 0x53]" :key="index">
          <div style="width: 80px; height: 80px; margin: 10px; background: red" :class="{ test_pressed: selectedKeys.includes(item) }"></div>
        </template> -->
      </div>

      <div class="tester_log_container">
        <div class="tester_log scrollbar_thumb">
          <div class="tester_log_item" v-for="(item, index) in testerLogs" :key="index">
            <span class="timer">{{ item.time }}</span>
            <div class="key">{{ kbVKTexture[item.key] }}</div>
            <span class="action">{{ $t(item.action) }}</span>
          </div>
          <div class="tester_log_item_end" ref="logEnd"></div>
        </div>
        <div class="reset button" @click="reset">{{ $t('reset') }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
const isShowTester = ref(false)
export { isShowTester }
</script>
<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from 'vue'
import Virtual_devices from '../device/virtual_devices.vue'
import { DevicePid, VK } from '@/define/define'
import { kbVKTexture } from '@/define/vkcode'
import { keyCodeToVKMap } from '@hid/recorder/key'
// import Mgx_travel from '../mgx_set/mgx_travel.vue';
// import { DriverService } from '@/service/driver/driver';
// import { DriverSocketMsgType } from '@libs/types/message';
// import { MagnetDynamicReport } from '@/service/driver/magnet_set';
// import { calibrationHandler } from '@/service/driver/calibration_set';
import { delay } from '@libs/utils/tools'
import { DeviceManager } from '@/service/device'

interface TesterLog {
  time: string
  key: VK
  action: 'down' | 'up'
}
const testerLogs = ref<TesterLog[]>([])
const disabledKeys: VK[] = [] // 浏览器不支持的键码 0xfa(fn), 0x5d(menu)
const selectedKeys = ref<VK[]>([])
const highlightedKeys = ref<VK[]>([])
const logEnd = ref<HTMLDivElement | null>(null)
// const travel = ref(0)

const resolveTesterKeyClass = (_kk: number, vk: VK): string[] => {
  const classes: string[] = []

  if (highlightedKeys.value.includes(vk)) {
    classes.push('tester_key_selected')
  }

  if (selectedKeys.value.includes(vk)) {
    classes.push('tester_key_pressed')
  }

  return classes
}

const back = () => {
  // calibrationHandler.endAllKeysWatchTrave()
  isShowTester.value = false
}
const getCurrentTime = (): string => {
  const date = new Date()
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const seconds = date.getSeconds().toString().padStart(2, '0')
  const milliseconds = date.getMilliseconds().toString().padStart(1, '0')[0]

  return `${hours}:${minutes}:${seconds}.${milliseconds}`
}
const updateScroll = async () => {
  if (logEnd.value) {
    await delay(1)
    logEnd.value.scrollIntoView({ behavior: 'smooth' })
  }
}
const addLogEntry = (key: number, action: 'down' | 'up') => {
  testerLogs.value.push({
    time: getCurrentTime(),
    key,
    action: action,
  })
}

const handleKeyAction = (event: KeyboardEvent, action: 'down' | 'up') => {
  event.preventDefault()
  let key: VK | undefined = keyCodeToVKMap[event.code]
  if (!key) {
    /* 某些浏览器可能无法正确识别 ShiftRight 的 event.code，尝试使用 location */
    if (event.key === 'Shift') {
      key = (event.location === 2 ? 0xa1 : 0xa0) as VK
    } else if (event.key === 'Control') {
      key = (event.location === 2 ? 0xa3 : 0xa2) as VK
    } else if (event.key === 'Alt') {
      key = (event.location === 2 ? 0xa5 : 0xa4) as VK
    }
  }
  if (!key || disabledKeys.includes(key)) return
  if (action === 'down') {
    if (event.repeat) return
    if (!highlightedKeys.value.includes(key)) {
      highlightedKeys.value.push(key)
      addLogEntry(key, 'down')
    }
  } else if (action === 'up') {
    const highlightIndex = highlightedKeys.value.indexOf(key)
    if (highlightIndex !== -1) {
      highlightedKeys.value.splice(highlightIndex, 1)
    }
    addLogEntry(key, 'up')
  }
  if (!selectedKeys.value.includes(key)) selectedKeys.value.push(key)
  updateScroll()
}

const handleKeyDown = (event: KeyboardEvent) => handleKeyAction(event, 'down')
const handleKeyUp = (event: KeyboardEvent) => handleKeyAction(event, 'up')
const reset = () => {
  highlightedKeys.value = []
  selectedKeys.value = []
  testerLogs.value = []
}
// const startMagnetDynamicMonitoring = () => {
//     calibrationHandler.startAllKeysWatchTrave()
//     DriverService.instance.setHandler(DriverSocketMsgType.MSMagnetDynamicKey, (res: MagnetDynamicReport[]) => {
//         travel.value = res.length > 0 ? Math.max(...res.map(obj => obj.Value)) : 0;
//     })
// }
watch(
  () => DeviceManager.instance.state.currentPid,
  (value: DevicePid) => {
    if (value == DevicePid.None) {
      isShowTester.value = false
    }
  },
)
onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
  window.addEventListener('keyup', handleKeyUp)
  // startMagnetDynamicMonitoring()
})
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown)
  window.removeEventListener('keyup', handleKeyUp)
  // calibrationHandler.endAllKeysWatchTrave()
})
</script>

<style scoped lang="less">
.test_pressed {
  background: var(--color-gray-1) !important;
  opacity: 0.5;
}

.white {
  .pressed {
    width: 100% !important;
    height: 100% !important;
    background: var(--color-gray-1) !important;
    opacity: 0.5;
  }
}
.tester_container {
  width: 100%;
  min-height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: var(--bg-main);
  background-attachment: fixed;

  .tester_device_container {
    display: flex;
    align-items: center;
    gap: 40px;
    margin-top: -40px;
    padding: 32px 36px;
    border-radius: var(--radius-l);
    background: var(--glass-panel-bg);
    backdrop-filter: var(--glass-panel-blur);
    box-shadow: var(--shadow-panel);
    min-height: 520px;

    .tester_device {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      border-radius: var(--radius-l);
      background: rgba(255, 255, 255, 0.75);
      backdrop-filter: var(--glass-surface-blur);
      border: var(--panel-border-soft);

      :deep(.board_view.keyboard_view) {
        padding: 24px;
        background: rgba(255, 255, 255, 0.82);
        border: 1px solid rgba(0, 0, 0, 0.05);
      }

      :deep(.board_view .device_key.keyboard_view_key) {
        background-color: rgba(255, 255, 255, 0.96);
        box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.04);
      }

      :deep(.board_view .device_key.keyboard_view_key:hover) {
        background-color: var(--color-white);
        box-shadow: var(--shadow-soft);
      }

      :deep(.board_view .device_key .texture) {
        color: rgba(34, 34, 34, 0.72);
        opacity: 1;
        font-weight: 700;
      }

      :deep(.board_view .device_key.tester_key_selected) {
        background: var(--brand-color);
        box-shadow: var(--action-btn-primary-shadow);
      }

      :deep(.board_view .device_key.tester_key_selected .texture) {
        color: var(--color-white) !important;
      }

      :deep(.board_view .device_key.tester_key_pressed) {
        background: rgba(var(--color-brand-1-rgb), 0.14) !important;
        box-shadow: inset 0 0 0 1px rgba(var(--color-brand-1-rgb), 0.18) !important;
      }

      :deep(.board_view .device_key.tester_key_pressed .texture) {
        color: rgba(34, 34, 34, 0.92);
      }
    }

    .tester_travel {
      margin-right: 40px;
    }

    .tester_log_container {
      background: var(--glass-surface-bg);
      backdrop-filter: var(--glass-surface-blur);
      border: var(--panel-border-soft);
      border-radius: var(--radius-l);
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .tester_log {
        overflow-y: scroll;
        width: 258px;
        height: 220px;
        margin: 20px 14px 20px 30px;

        .tester_log_item {
          margin-top: 12px;
          display: flex;
          align-items: center;

          .timer {
            color: var(--color-text-hint);
            font-size: 14px;
            margin-right: 30px;
          }

          .key {
            color: var(--color-white);
            min-width: 40px;
            padding: 8px 10px;
            height: 36px;
            border-radius: var(--radius-s);
            border: 1px solid rgba(var(--color-brand-1-rgb), 0.15);
            background: var(--brand-color);
            margin-right: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          }

          .action {
            color: var(--color-dark);
            font-size: 14px;
            font-weight: 600;
          }
        }
      }

      .reset {
        position: absolute;
        bottom: -72px;
        height: 42px;
        padding: 0 40px;
        background: var(--btn-base-bg);
        border: var(--btn-base-border);
        color: var(--btn-base-text);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-m);
        font-weight: 600;
        box-shadow: var(--action-btn-shadow);
        transition: var(--transition-base);

        &:hover {
          transform: translateY(-2px);
          background: var(--color-white);
          box-shadow: var(--action-btn-shadow-hover);
        }

        &:active {
          transform: translateY(-1px);
        }
      }
    }
  }
}

&::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
}
</style>
